/* eslint max-len: ["error", 250] */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import constant from '../../../constants'

export default class Twitter extends Component {
  twitterSignUp = () => {
    let height
    let width
    const w = constant.TWITTER_MODAL_WIDTH
    const h = constant.TWITTER_MODAL_HEIGHT
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top

    // calculate corrected width
    if (window.innerWidth) {
      width = window.innerWidth
    } else {
      width = document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
    }

    // calculate corrected height
    if (window.innerHeight) {
      height = window.innerHeight
    } else {
      height = document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height
    }

    // calculate corrected position
    const left = ((width / 2) - (w / 2)) + dualScreenLeft
    const top = ((height / 2) - (h / 2)) + dualScreenTop

    const modalWindow = window.open(constant.TWITTER_URI, 'twitter', `toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,width=${w},height=${h},top=${top},left=${left}`)

    const timer = setInterval(() => {
      if (modalWindow && modalWindow.closed) {
        this.props.onLoginResponse()
        clearInterval(timer)
      }
    }, 500)
  }

  render() {
    return (
      <button onClick={this.twitterSignUp} className="join-with tw xs-border-none xs-block">
        <span className="join-text xs-pt3 xs-pl4 xs-float-left xs-text-white">{this.props.buttonText}</span>
        <span className="tw-logo xs-float-right xs-mx2 xs-my3" />
      </button>
    )
  }
}

Twitter.propTypes = {
  onLoginResponse: PropTypes.func,
  buttonText: PropTypes.string,
}

Twitter.defaultProps = {
  onLoginResponse: PropTypes.func,
  buttonText: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/social/twitter/twitter.js